export default defineNuxtRouteMiddleware( async () => {
  const requestUrl = useRequestURL();

  if ( !requestUrl.origin.includes( "dev" ) ) {
    console.warn( "Clearing basket cookie" );
    const basketCookie = useCookie( "apollo-basket-id" );
    basketCookie.value = null;

    const basketStreamCookie = useCookie( "apollo-basket-stream-id" );
    basketStreamCookie.value = null;
  }
} );
